import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { getSiteData } from '../store/actions'
import { baseURL2 } from '../helper/helper'
import buildingImg from '../assets/building.jpg'
import { ArrowRight } from 'lucide-react'

export default function Institution() {
    const dispatch = useDispatch()
    const { institutions, loading } = useSelector((state) => state.reducer || {})

    useEffect(() => {
        if (!institutions || institutions.length === 0) {
            dispatch(getSiteData())
        }
        window.scrollTo(0, 0)
    }, [dispatch, institutions])

    return (
        <div className="min-h-screen bg-white text-gray-900 pb-24">
            <section className="pt-32 pb-16 px-6 max-w-4xl mx-auto text-center">
                <span className="text-xs tracking-widest uppercase text-secondary font-semibold mb-6 block">The Foundation Network</span>
                <h1 className="text-4xl md:text-6xl font-light text-primary tracking-tight leading-tight mb-8">
                    Educational <span className="font-medium text-secondary">Sanctuaries</span>.
                </h1>
                <p className="text-lg md:text-xl text-gray-500 font-light max-w-2xl mx-auto leading-relaxed">
                    Explore a prestigious network of specialized campuses dedicated to nurturing the next generation of spiritual and intellectual leaders.
                </p>
            </section>

            <section className="py-16 px-6 md:px-12 max-w-7xl mx-auto border-t border-gray-100">
                {loading && !institutions ? (
                    <div className="py-24 text-center text-secondary tracking-widest uppercase text-sm animate-pulse font-semibold">
                        Loading Network...
                    </div>
                ) : institutions && institutions.length > 0 ? (
                    <div className="space-y-24">
                        {institutions.map((inst, index) => (
                            <div key={inst.id || index} className={`flex flex-col lg:flex-row gap-12 md:gap-24 items-center ${index % 2 !== 0 ? 'lg:flex-row-reverse' : ''}`}>
                                <div className="w-full lg:w-1/2 overflow-hidden bg-primary/5 rounded-[40px] aspect-[4/3] group relative">
                                    <div className="absolute inset-0 bg-primary/20 mix-blend-overlay group-hover:bg-transparent transition-colors z-10 duration-700 pointer-events-none"></div>
                                    <img
                                        loading="lazy"
                                        src={inst.photo ? (inst.photo.startsWith('http') ? inst.photo : (baseURL2 + inst.photo)) : buildingImg}
                                        alt={inst.name}
                                        className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
                                    />
                                </div>
                                <div className="w-full lg:w-1/2 flex flex-col justify-center">
                                    <span className="text-xs font-semibold text-secondary uppercase tracking-[5px] mb-4">Branch Data</span>
                                    <h2 className="text-3xl md:text-5xl font-light text-primary mb-6 leading-tight">
                                        {inst.name}
                                    </h2>
                                    <div className="w-12 h-px bg-secondary mb-8"></div>
                                    <p className="text-gray-600 text-lg leading-relaxed mb-10 font-light">
                                        {inst.description || "A dedicated branch emphasizing spiritual character building and scholastic excellence in both traditional and modern disciplines."}
                                    </p>
                                    <div className="flex flex-wrap gap-6">
                                        <Link
                                            to={`/institution/${inst.slug}`}
                                            className="px-8 py-3 bg-primary text-white font-semibold rounded-xl text-xs uppercase tracking-widest hover:bg-secondary transition-colors shadow-lg shadow-primary/20 flex items-center gap-3"
                                        >
                                            Explore <ArrowRight size={14} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="py-24 text-center text-gray-400 text-sm tracking-widest">
                        No branches available.
                    </div>
                )}
            </section>

            <section className="py-24 max-w-4xl mx-auto text-center border-t border-gray-100 px-4">
                <h5 className="text-3xl font-light mb-8 text-primary">Need help choosing a campus?</h5>
                <Link
                    to="/contact"
                    className="inline-block px-10 py-4 bg-primary/5 border border-primary/20 text-primary font-bold rounded-xl hover:bg-primary hover:text-white transition-colors text-sm uppercase tracking-widest"
                >
                    Speak with Counselor
                </Link>
            </section>
        </div>
    )
}